"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = void 0;
var react_1 = __importStar(require("react"));
var LabelContext_1 = require("../labels/LabelContext");
var GroupContext_1 = require("../layout/GroupContext");
var classnames_1 = __importDefault(require("classnames"));
var InputBase_scss_1 = __importDefault(require("./InputBase.scss"));
var TextInput = function (_a) {
    var _b;
    var _c = _a.size, size = _c === void 0 ? 'block' : _c, props = __rest(_a, ["size"]);
    var _d = (0, react_1.useState)(props.value), value = _d[0], setValue = _d[1];
    (0, react_1.useEffect)(function () {
        if (value != props.value) {
            setValue(props.value);
        }
    }, [props.value]);
    var onChange = function () {
        if (value != props.value) {
            props.onChange && props.onChange(value);
        }
    };
    var labelCtx = (0, react_1.useContext)(LabelContext_1.LabelContext);
    var groupCtx = (0, react_1.useContext)(GroupContext_1.GroupContext);
    var state = labelCtx.state || props.state;
    return (react_1.default.createElement("input", { id: props.id || labelCtx.id, name: props.name, type: props.type, className: (0, classnames_1.default)(InputBase_scss_1.default["au-text-input"], (_b = {},
            _b[InputBase_scss_1.default["au-text-input--".concat(state)]] = state,
            _b[InputBase_scss_1.default["au-text-input--width-".concat(size)]] = size && size != 'block',
            _b[InputBase_scss_1.default["au-text-input--block"]] = size == 'block',
            _b), groupCtx.className, props.className), "aria-labelledby": props.describedBy || labelCtx.describedBy, value: value, onChange: function (e) { return setValue(e.target.value); }, onBlur: onChange, disabled: props.disabled, readOnly: props.readonly, style: props.rightAlign ? { textAlign: "right" } : {}, placeholder: props.placeholder, maxLength: props.maxLength, onKeyUp: function (e) { return props.onEnter && (e.key === 'Enter' || e.keyCode === 13) && props.onEnter(e.currentTarget.value); } }));
};
exports.TextInput = TextInput;
//# sourceMappingURL=TextInput.js.map